export const brl = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const dt = (s) => {
  if (!s) return "—";
  const [y, m, d] = s.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};

export const dtTime = (s) => (s ? new Date(s).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "—");

export const todayISO = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export const monthStart = () => todayISO().slice(0, 8) + "01";

export const addDays = (iso, n) => {
  const d = new Date(iso + "T12:00:00");
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const WEEKDAYS = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

export const METHOD_LABEL = {
  pix: "Pix", dinheiro: "Dinheiro", cartao: "Cartão (Stripe)", cartao_maquina: "Cartão (maquininha)",
  transferencia: "Transferência", cartao_recorrente: "Cartão recorrente", pendente: "A receber",
};

export const CHANNEL_LABEL = { recorrente: "Stripe recorrente", avulso: "Stripe avulso", manual: "Fora do Stripe" };

export const PERIOD_LABEL = { mensal: "Mensal", trimestral: "Trimestral", semestral: "Semestral", anual: "Anual" };

export const ROLE_LABEL = { admin: "Administrador", professor: "Professor", aluno: "Aluno", responsavel: "Responsável legal" };
